
    import './styles.scoped.css';
    export default {
  "css-grid": "awsui_css-grid_zqq3x_1mxwp_9",
  "grid-no-gutters": "awsui_grid-no-gutters_zqq3x_1mxwp_20",
  "grid-variant-text-grid": "awsui_grid-variant-text-grid_zqq3x_1mxwp_23",
  "item": "awsui_item_zqq3x_1mxwp_23",
  "first-column": "awsui_first-column_zqq3x_1mxwp_40"
};
  